import { v4 as uuidv4Fn } from "uuid"

export function uuidv4(): string {
  return uuidv4Fn()
}
